import { DART_HITS, DART_NUMBER, X01_ASP } from "./dart";
import { BaseGameState, BasePlayerState, BaseTeamState } from "./game";
import { TEAM } from "./teams";

export enum InOut {
  DOUBLE_IN_DOUBLE_OUT = "Double In/Double Out",
  ANY_IN_DOUBLE_OUT = "Straight In/Double Out",
  ANY_IN_ANY_OUT = "Straight In/Straight Out",
  MANUAL_NUMPAD = "Manual Numpad",
}

export const requiredDoubleIn = [InOut.DOUBLE_IN_DOUBLE_OUT];
export const requiredDoubleOut = [InOut.DOUBLE_IN_DOUBLE_OUT, InOut.ANY_IN_DOUBLE_OUT];

export const X01Order = [
  DART_NUMBER.TWENTY,
  DART_NUMBER.NINETEEN,
  DART_NUMBER.EIGHTEEN,
  DART_NUMBER.SEVENTEEN,
  DART_NUMBER.SIXTEEN,
  DART_NUMBER.FIFTEEN,
  DART_NUMBER.FOURTEEN,
  DART_NUMBER.THIRTEEN,
  DART_NUMBER.TWELVE,
  DART_NUMBER.ELEVEN,
  DART_NUMBER.TEN,
  DART_NUMBER.NINE,
  DART_NUMBER.EIGHT,
  DART_NUMBER.SEVEN,
  DART_NUMBER.SIX,
  DART_NUMBER.FIVE,
  DART_NUMBER.FOUR,
  DART_NUMBER.THREE,
  DART_NUMBER.TWO,
  DART_NUMBER.ONE,
  DART_NUMBER.BULL,
];

export const X01VerticalOrder = [
  DART_NUMBER.TWENTY,
  DART_NUMBER.THIRTEEN,
  DART_NUMBER.SIX,
  DART_NUMBER.NINETEEN,
  DART_NUMBER.TWELVE,
  DART_NUMBER.FIVE,
  DART_NUMBER.EIGHTEEN,
  DART_NUMBER.ELEVEN,
  DART_NUMBER.FOUR,
  DART_NUMBER.SEVENTEEN,
  DART_NUMBER.TEN,
  DART_NUMBER.THREE,
  DART_NUMBER.SIXTEEN,
  DART_NUMBER.NINE,
  DART_NUMBER.TWO,
  DART_NUMBER.FIFTEEN,
  DART_NUMBER.EIGHT,
  DART_NUMBER.ONE,
  DART_NUMBER.FOURTEEN,
  DART_NUMBER.SEVEN,
  DART_NUMBER.BULL,
];

export enum X01_ORDER {
  VERTICAL = "vertical",
  HORIZONTAL = "horizontal"
}

export interface X01TeamState extends BaseTeamState {
  players: X01PlayerState[];
  previousRounds: PreviousRounds[];
  doubledIn: boolean;
  roundScore: number;
}

export interface X01GameState extends BaseGameState {
  x01Game: number;
  inOut: InOut;
  [TEAM.ONE]: X01TeamState;
  [TEAM.TWO]: X01TeamState;
};

export interface PreviousRounds {
  startingScore: number;
  roundScore: number;
}

export interface X01ASPs {
  [X01_ASP.TWENTY_SIX]: number;
  [X01_ASP.TON]: number;
  [X01_ASP.TON_TWENTY]: number;
  [X01_ASP.TON_FORTY]: number;
  [X01_ASP.TON_SIXTY]: number;
  [X01_ASP.TON_EIGHTY]: number;
}

export interface X01PlayerState extends BasePlayerState {
  inShots: number;
  outShots: number;
  asps: X01ASPs;
  scored: number;
  gotIn: boolean;
  gotOut: boolean;
};

export interface X01ASPWithThrow extends X01ASPs {
  throws: number;
  scored: number;
}

export interface X01Results {
  [TEAM.ONE]: {
    leg: X01ASPWithThrow;
    match: X01ASPWithThrow;
  }[];
  [TEAM.TWO]: {
    leg: X01ASPWithThrow;
    match: X01ASPWithThrow;
  }[];
}

export const potentialOuts = X01Order.map(number => number * DART_HITS.DOUBLE);
export const dartAndScores = X01Order.map(number => {
  const scores = [number, number * DART_HITS.DOUBLE];
  if (number !== DART_NUMBER.BULL) {
    scores.push(number * DART_HITS.TRIPLE)
  }
  return {
    dart: number,
    scores
  }
})